import { type FC } from 'react';
import { Button } from '@matrix-forge/ui/components/button';

/**
 * LogoutSuccess component
 *
 * Displayed after successful logout from Keycloak
 * Provides a clean landing page and option to login again
 */
export const LogoutSuccess: FC = () => {
  const handleLoginAgain = () => {
    // Clear any remaining state and go to login
    window.location.href = '/studio/';
  };

  return (
    <div className="h-full w-full flex items-center justify-center bg-background">
      <div className="text-center max-w-md p-8">
        <div className="text-green-500 text-6xl mb-6">✓</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">You've been logged out</h1>
        <p className="text-gray-600 mb-8">
          Your session has ended successfully. All authentication data has been cleared.
        </p>
        <Button onClick={handleLoginAgain} size="lg" className="w-full">
          Login Again
        </Button>
      </div>
    </div>
  );
};
